<div *ngIf="data" class="results-message">
  <div class="image-container">
    <img [src]="data.imgSrc" [alt]="data.imgAlt" class="responsive-img"/>
  </div>
  <h2 class="text-message" [dir]="data.directionText">{{ data.title | translate }}</h2>
</div>